import { SVGProps } from "react";

export const ListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0333 2C12.7681 2 13.3666 2.59848 13.3666 3.33333V12.6198C13.3666 12.6627 13.362 12.7048 13.3542 12.7454C13.2973 13.3772 12.8155 14 12.073 14H3.98641C3.18398 13.9998 2.69995 13.2868 2.69995 12.6198V3.38021C2.69995 2.70826 3.19493 2.00022 3.98641 2H12.0333ZM5.36011 10.0938C5.06556 10.0938 4.8269 10.3324 4.8269 10.627C4.82706 10.9214 5.06565 11.1602 5.36011 11.1602H10.6934C10.9879 11.1602 11.2265 10.9214 11.2266 10.627C11.2266 10.3324 10.988 10.0938 10.6934 10.0938H5.36011ZM5.36011 7.44661C5.06561 7.44661 4.82699 7.68534 4.8269 7.97982C4.8269 8.27437 5.06556 8.51302 5.36011 8.51302H10.6934C10.988 8.51302 11.2266 8.27437 11.2266 7.97982C11.2266 7.68534 10.9879 7.44661 10.6934 7.44661H5.36011ZM5.36011 4.80013C5.06556 4.80013 4.8269 5.03878 4.8269 5.33333C4.8269 5.62789 5.06556 5.86654 5.36011 5.86654H7.36011C7.65466 5.86654 7.89331 5.62789 7.89331 5.33333C7.89331 5.03878 7.65466 4.80013 7.36011 4.80013H5.36011Z"
    />
  </svg>
);
